import React, { FC } from 'react';

/* types */
import { RadioProps as MuiRadio } from '@mui/material';

/* styled */
import { StyledMuiRadio, StyledIcon, StyledCheckedIcon } from './styled';

export const Radio: FC<MuiRadio> = (props) => {
  return <StyledMuiRadio icon={<StyledIcon />} checkedIcon={<StyledCheckedIcon />}  {...props} />;
};
